module.exports = __webpack_public_path__ + "static/media/edit.6a8020da.svg";